import { Flex, Modal, Select, Text } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";

import { useLogout } from "../../../hooks";
import { Button } from "../Button/Button";
import { type RotationUser } from "./login.model";

interface Props {
  open?: boolean;
  close: () => void;
  onYes: (params: any) => void;
  list?: RotationUser[];
  params?: any;
}
const RotationModal = ({ onYes, close, open, list, params }: Props) => {
  const logout = useLogout();
  const [selectedUser, setSelectedUser] = useState<string | null>(null);

  useEffect(() => {
    setSelectedUser(null);
  }, [open]);

  const handleYes = () => {
    if (!selectedUser) return;
    onYes({ ...params, selected: selectedUser });
    close();
  };

  const handleNo = async () => {
    await logout();
    close();
  };

  const parsedToSelect = useMemo(
    () =>
      list
        ? list.map(item => ({ value: item.userid, label: item.full_name }))
        : [],
    [list],
  );

  const matchedUserData = useMemo(
    () => (list ? list.find(item => item.active === 1) : null),
    [list, selectedUser],
  );

  if (!list) return null;

  return (
    <Modal
      onClose={handleNo}
      withCloseButton={false}
      yOffset={"20dvh"}
      opened={Boolean(open)}
      closeOnClickOutside={false}
      title="Onboard/Rotational Leave Warning">
      <Flex
        style={{ height: "250px" }}
        direction="column"
        justify="space-between">
        <Select
          data={parsedToSelect}
          value={selectedUser}
          onChange={setSelectedUser}
          label="Choose your name from the dropdown list and update the other crew member's status to ”on rotational leave”"
        />
        <Flex direction="column" gap="10px">
          {matchedUserData &&
            matchedUserData.active === 1 &&
            selectedUser &&
            selectedUser !== matchedUserData.userid && (
              <div
                style={{
                  padding: "5px",
                  border: "1px solid rgba(255,0,0,0.5)",
                  borderRadius: "10px",
                  backgroundColor: "rgba(255,0,0,0.05)",
                }}>
                <Text size="sm" c="red">
                  You are currently marked as on rotational leave,{" "}
                  <span style={{ fontWeight: "bolder", color: "black" }}>
                    {matchedUserData.full_name}
                  </span>{" "}
                  will be marked as on rotational leave so you can automatically
                  be marked as onboard.
                </Text>
              </div>
            )}
          <Flex w={"100%"} justify={"center"} gap={20}>
            <Button onClick={handleNo} color="red">
              Discard
            </Button>
            <Button onClick={handleYes} color="blue" disabled={!selectedUser}>
              Rotate
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
};
export default RotationModal;
